import { render, staticRenderFns } from "./ceping-detail.vue?vue&type=template&id=d206e412&scoped=true&"
import script from "./ceping-detail.vue?vue&type=script&lang=ts&"
export * from "./ceping-detail.vue?vue&type=script&lang=ts&"
import style0 from "./ceping-detail.vue?vue&type=style&index=0&id=d206e412&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d206e412",
  null
  
)

export default component.exports